import { ISOTimeStamp } from "../../../../../../library/ts/vanilla/time/ISOTimeStamp";
import { CryptoTool } from "../../../../../../library-js/random/CryptoTool";

export enum ReminderEntryType
{
  Mail, Clock, Calender
}

export class ReminderEntry 
{
  type:ReminderEntryType;
  id:string;
  creationTime:ISOTimeStamp;

  static initialize( r:ReminderEntry )
  {
    r.id = CryptoTool.randomUUID();
    r.type = ReminderEntryType.Mail;
    r.creationTime = ISOTimeStamp.now();    
  }
}